import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { ApiMeta } from '../../../_core/_model/api-response';
import { AdditionalDocumentRequestListItemDto } from '../../../_core/_model/additional-documents';
import { AdditionalDocumentsService } from '../../../_core/_services/additional-documents.service';
import { NotificationService } from '../../../_core/_services/notification.service';

@Component({
  selector: 'app-additional-document-list',
  standalone: false,
  templateUrl: './additional-document-list.html',
  styleUrl: './additional-document-list.css'
})
export class AdditionalDocumentList implements OnInit {
  loading = false;
  error: string | null = null;
  status = '';
  page = 1;
  items: AdditionalDocumentRequestListItemDto[] = [];
  meta: ApiMeta | null = null;

  readonly statuses = [
    { value: '', label: 'All requests' },
    { value: 'Requested', label: 'Upload required' },
    { value: 'AwaitingReplacement', label: 'Replacement required' },
    { value: 'Submitted', label: 'Submitted' },
    { value: 'UnderReview', label: 'Under review' },
    { value: 'Approved', label: 'Approved' }
  ];

  constructor(
    private documents: AdditionalDocumentsService,
    private router: Router,
    private notify: NotificationService
  ) {}

  ngOnInit(): void {
    this.load();
  }

  load(page = 1): void {
    this.page = page;
    this.loading = true;
    this.error = null;

    this.documents.getMine(this.status || null, page)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe({
        next: response => {
          this.items = response.data || [];
          this.meta = response.meta || null;
        },
        error: error => {
          this.items = [];
          this.meta = null;
          this.error = error?.error?.message || 'Unable to load document requests.';
          this.notify.showError(this.error!, 'Additional Documents');
        }
      });
  }

  open(item: AdditionalDocumentRequestListItemDto): void {
    this.router.navigate(['/account/additional-documents', item.id]);
  }

  requiresAction(item: AdditionalDocumentRequestListItemDto): boolean {
    return ['Requested', 'AwaitingReplacement'].includes(item.status);
  }

  statusClass(status: string): string {
    switch (status) {
      case 'Approved': return 'text-bg-success';
      case 'Requested':
      case 'AwaitingReplacement': return 'text-bg-danger';
      case 'Submitted':
      case 'UnderReview': return 'text-bg-warning';
      case 'Cancelled':
      case 'Expired': return 'text-bg-secondary';
      default: return 'text-bg-info';
    }
  }
}
